export default __webpack_public_path__ + "static/media/valeIcon.6d4abe12.svg";